// extracted by mini-css-extract-plugin
export default {"container":"ExamBadge_container__lP0t0","bordered":"ExamBadge_bordered__TMDyO","large":"ExamBadge_large__u+7y2"};